// extracted by mini-css-extract-plugin
export default {"overlay":"ew-z","bodyOpen":"fw-z","content":"gw-z","header":"hw-z","close":"iw-z","closeNoHeading":"jw-z"};